import { actions as formActions } from 'react-redux-form';
import { formatText } from 'core/i18n';
import apiURLBuilder from '../core/apiURLBuilder';
import Api from '../services/api';
import actionTypes from 'constants/actionTypes';
import { ASNEF_ERROR } from 'constants/pollingConstants';
import { goToErrorsView } from './errorViewNavigation';

const clientIdentificationIbanService = (dispatch, iban, accessToken, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: {
            iban,
        },
    };
    Api.post(apiURLBuilder.getURL('clientIdentificationIban'), requestData).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                callback(true);
            } else {
                callback(false, data.errors);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const getVideoCallService = (dispatch, accessToken, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    Api.post(apiURLBuilder.getURL('clientIdentificationVideoCall'), requestData).then(
        response => {
            if (response.body) {
                const data = response.body;
                dispatch({
                    type: actionTypes.VIDEO_CALL_URL,
                    data,
                });
                callback(true);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const getUnassistedVideoCallService = (dispatch, accessToken, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    Api.post(apiURLBuilder.getURL('clientIdentificationUnassistedVideoCall'), requestData).then(
        response => {
            if (response.body) {
                const data = response.body;
                dispatch({
                    type: actionTypes.VIDEO_CALL_URL,
                    data,
                });
                callback(true);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const getIdentificationStatus = (dispatch, accessToken, callback) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    Api.get(apiURLBuilder.getURL('getClientIdentificationStatus'), requestData).then(
        response => {
            if (response.body) {
                const data = response.body;
                dispatch({
                    type: actionTypes.VIDEO_CALL_STATUS,
                    data,
                });
                callback(true);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const getPopulation = marker => {
    const splitMarkerAddress = marker && marker.address && marker.address.split(',');

    return (splitMarkerAddress && splitMarkerAddress[splitMarkerAddress.length - 1].trim()) || '';
};

const definiteKO = dispatch => {
    dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-warning'));
    dispatch(formActions.change('userProfile.errorTitle', formatText('messagesScreen-defaultErrorTitle')));
    dispatch(formActions.change('userProfile.errorSubtitle', ''));
    dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
    dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-primary'));
    dispatch(
        goToErrorsView({
            errorMessage: 'messagesScreen-defaultErrorContent',
            errorContent: 'messagesScreen-defaultErrorContent',
        })
    );
};

const callcenterKO = dispatch => {
    dispatch(formActions.change('userProfile.errorIconClass', 'icons icons--icon-clock-type-2'));
    dispatch(
        formActions.change('userProfile.errorTitle', formatText('messagesScreen-identityVerificationInProcessTitle'))
    );
    dispatch(formActions.change('userProfile.errorSubtitle', ''));
    dispatch(formActions.change('userProfile.buttonText', formatText('button-understood')));
    dispatch(formActions.change('userProfile.buttonClass', 'form__button form__button-secondary'));
    dispatch(
        goToErrorsView({
            errorCode: ASNEF_ERROR,
            errorMessage: 'messagesScreen-identityVerificationInProcessContent',
            errorContent: 'messagesScreen-identityVerificationInProcessContent',
        })
    );
};

const correosOK = (dispatch, marker) => {
    dispatch(formActions.change('userProfile.postOfficeBranch', marker.unidad));
    dispatch(formActions.change('userProfile.postOfficeAddress', marker.address));
    dispatch(formActions.change('userProfile.postOfficePopulation', getPopulation(marker)));
    dispatch(formActions.change('userProfile.postOfficePhone', marker.phone));
    dispatch(formActions.change('userProfile.postOfficeDescription', marker.description));
    dispatch(formActions.change('userProfile.postOfficeHours1', marker.officeHours1.replace('DE ', '').toLowerCase()));
    dispatch(formActions.change('userProfile.postOfficeHours2', marker.officeHours2.replace('DE ', '').toLowerCase()));
    dispatch(formActions.change('userProfile.postOfficeHours3', marker.officeHours3.replace('DE ', '').toLowerCase()));
    dispatch(formActions.change('userProfile.identityStatus', 'programmed'));
    dispatch(formActions.change('userProfile.identityMethod', 'correos'));
};

const clientIdentificationCorreosService = (dispatch, marker, accessToken, callback) => {
    Api.post(apiURLBuilder.getURL('clientIdentificationCorreosV3'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
            version: '3',
        },
        query: {
            branch: marker.unidad,
            postalCode: marker.postalCode,
            population: getPopulation(marker),
        },
    }).then(
        response => {
            const data = response.body;

            if (data.status === 'OK') {
                correosOK(dispatch, marker);
                callback(true);
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const saveCourierAddress = (courierAddress, accessToken, callback) => {
    return dispatch => {
        Api.post(apiURLBuilder.getURL('saveCourierAddress'), {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
            query: courierAddress,
        }).then(
            response => {
                dispatch({
                    type: actionTypes.SAVE_COURIER_ADDRESS,
                    payload: response.body,
                });
                callback(true);
            },
            error => {
                callback(false, error);
            }
        );
    };
};

const clientIdentificationCourierService = (dispatch, courierData, accessToken, callback) => {
    Api.post(apiURLBuilder.getURL('clientIdentificationCourier'), {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
        query: courierData,
    }).then(
        response => {
            const data = response.body;
            if (data.status === 'OK') {
                const date = data.date;
                dispatch(formActions.change('userProfile.identityMethod', 'courier'));
                dispatch(formActions.change('userProfile.identityStatus', 'programmed'));
                dispatch(formActions.change('userProfile.courierDate', date));
                dispatch(formActions.change('userProfile.courierPostoned', data.postponed));
                callback(true);
            } else {
                callback(false, data);
            }
        },
        error => {
            callback(false, error);
        }
    );
};

const getVideoCallResult = (dispatch, accessToken) => {
    const requestData = {
        header: {
            Authorization: `Bearer ${accessToken}`,
        },
    };
    Api.get(apiURLBuilder.getURL('videocallStatus'), requestData).then(response => {
        if (response.body) {
            const data = response.body;
            dispatch({
                type: actionTypes.VIDEO_CALL_STATUS,
                data,
            });
        }
    });
};

const getVideoIdentificationAvailability = accessToken => {
    return dispatch => {
        const requestData = {
            header: {
                Authorization: `Bearer ${accessToken}`,
            },
        };
        Api.get(apiURLBuilder.getURL('videoIdentificationAvailability'), requestData).then(response => {
            if (response.body) {
                const data = response.body;
                dispatch({
                    type: actionTypes.VIDEO_AVAILABILITY,
                    data,
                });
            }
        });
    };
};

const clientIdentificationIban = (iban, accessToken, callback) => {
    return dispatch => {
        clientIdentificationIbanService(dispatch, iban, accessToken, callback);
    };
};

const clientIdentificationVideoCall = (accessToken, callback) => {
    return dispatch => {
        getVideoCallService(dispatch, accessToken, callback);
    };
};

const clientIdentificationUnassistedVideoCall = (accessToken, callback) => {
    return dispatch => {
        getUnassistedVideoCallService(dispatch, accessToken, callback);
    };
};

const clientIdentificationStatus = (accessToken, callback) => {
    return dispatch => {
        getIdentificationStatus(dispatch, accessToken, callback);
    };
};

const clientDefiniteKO = () => {
    return dispatch => {
        definiteKO(dispatch);
    };
};

const callCenterKO = () => {
    return dispatch => {
        callcenterKO(dispatch);
    };
};

const clientIdentificationCorreos = (marker, accessToken, callback) => {
    return dispatch => {
        clientIdentificationCorreosService(dispatch, marker, accessToken, callback);
    };
};

const clientIdentificationCourier = (courierData, accessToken, callback) => {
    return dispatch => {
        clientIdentificationCourierService(dispatch, courierData, accessToken, callback);
    };
};

const resetVideoCallStatus = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.VIDEO_CALL_RESET,
        });
    };
};

const videoCallResult = accessToken => {
    return dispatch => {
        getVideoCallResult(dispatch, accessToken);
    };
};

export default {
    clientIdentificationIban,
    clientIdentificationVideoCall,
    clientIdentificationStatus,
    getVideoIdentificationAvailability,
    clientDefiniteKO,
    clientIdentificationCorreos,
    clientIdentificationCourier,
    resetVideoCallStatus,
    videoCallResult,
    saveCourierAddress,
    clientIdentificationUnassistedVideoCall,
    callCenterKO,
    callcenterKO,
};
